export default (defaultState, isSync = true) =>
  (reducer) => {
    let initializedDefaultState = null

    return (state, payload) => {
      if (state == null) {
        if (initializedDefaultState == null) {
          initializedDefaultState = isSync ? defaultState : defaultState()
        }

        state = initializedDefaultState()
      }

      return reducer(state, payload)
    }
  }
